import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/packages/components/layouts/default-page-layout/default-page-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/packages/components/templates/page/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/home/vsts/work/1/s/packages/libraries/contexts/i18n-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteSettingsProvider"] */ "/home/vsts/work/1/s/packages/libraries/contexts/site-settings-context.tsx");
